/* eslint-disable no-param-reassign,no-unused-vars */
/* global G */
import ui from 'lib/hook/ui/update'
import recall from 'app/_shared/hook/component/recall'
import uiTitle from 'app/equipmentInformation/hook/uiTitle'
import check from 'app/_shared/hook/check'
import submitAttribute from 'lib/hook/model/submitAttribute'
import readAttribute from 'lib/hook/model/readAttribute'
import cacheAttributeTitle from 'app/_shared/hook/model/cacheAttributeTitle'
import validateAttribute from 'lib/hook/model/validateAttribute'
import action, { currentAction } from 'lib/hook/module/action'
import { begin, confirmation, end } from 'lib/hook/transaction'
import platform from 'app/_shared/hook/platform'
import quickActions, { componentQuickActions } from 'app/_shared/hook/appbar/quickActions'
import resetComponent from 'app/_shared/hook/component/reset'
import back from 'app/_shared/hook/appbar/back'
import uiEquipmentTitle from 'app/equipmentInformation/hook/uiEquipmentTitle'
import search from 'app/_shared/hook/appbar/search'
import confirm from 'lib/hook/router/confirm'
import previous from 'app/_shared/hook/redirect/back'
import resetAttribute from 'lib/hook/model/resetAttribute'
import attachmentApplyAttribute from 'lib/hook/attachment/apply'

const _baseHooks = {
  before: [],
  after: [
    ui,
  ],
}

const _indexHooks = {
  before: [],
  after: [
    platform({
      mobile: [recall, quickActions],
    }),
    ui,
  ],
}

const _electricDiagramHooks = {
  before: [],
  after: [
    platform({
      mobile: quickActions,
    }),
    ui,
  ],
}

const _treeHooks = {
  before: [
    recall,
  ],
  after: [
    platform({
      mobile: [back, componentQuickActions('right')],
    }),
    ui,
  ],
}

const _explosionDrawingHooks = {
  before: [
    platform({
      mobile: [search],
    }),
    recall,
  ],
  after: [
    platform({
      mobile: [back, uiEquipmentTitle],
    }),
    ui,
  ],
}

const _partsHooks = {
  before: [
    readAttribute('article'),
    cacheAttributeTitle('article')('name', 'number'),
  ],
  after: [
    platform({
      mobile: quickActions,
    }),
    ui,
  ],
}

const _equipmentHooks = {
  before: [
    readAttribute('equipment'),
    cacheAttributeTitle('equipment')('name', 'serial'),
  ],
  after: [
    platform({
      mobile: quickActions,
    }),
    ui,
  ],
}

const _pdfHooks = {
  before: [],
  after: [
    platform({
      mobile: quickActions,
    }),
    ui,
  ],
}

const _attachmentHooks = {
  before: [],
  after: [
    platform({
      mobile: quickActions,
    }),
    uiTitle,
    ui,
  ],
}

const _attachmentTreeHooks = {
  before: [],
  after: [
    platform({
      mobile: [back, componentQuickActions('right')],
    }),
    uiTitle,
    ui,
  ],
}

const _submitFeedbackHooks = {
  before: [
    validateAttribute('documentationFeedback', 'feedback'),
  ],
  after: [
    ui,
    check,
    submitAttribute('documentationFeedback'),
    confirmation('feedback', 'success'),
    action('successFeedback'),
  ],
}

const _submitFavoriteHooks = {
  before: [],
  after: [
    ui,
    check,
    confirmation('favorite', 'success'),
    action('successFavorite'),
  ],
}

const _successHooks = {
  before: [],
  after: [
    currentAction,
  ],
}

const _installationReportCreateHooks = {
  before: [
    resetComponent,
  ],
  after: [
    ui,
    confirm,
  ],
}

const _installationReportEditHooks = {
  before: [
    // clear,
    resetComponent,
    readAttribute('installationReport'),
  ],
  after: [
    ui,
    confirm,
  ],
}

const _installationReportSubmitHooks = {
  before: [
    validateAttribute('installationReport'),
  ],
  after: [
    ui,
    check,
    begin,
    submitAttribute('installationReport'),
    attachmentApplyAttribute('installationReport'),
    resetAttribute('installationReport'),
    // confirmation('success'),
    previous,
    end,
  ],
}

const hooks = {
  [G.ACTIONS]: {
    document: _indexHooks,
    equipment: _equipmentHooks,
    equipmentDetails: _indexHooks,
    part: _partsHooks,
    upload: _baseHooks,
    images: _baseHooks,
    explosionDrawing: _explosionDrawingHooks,
    soon: _indexHooks,
    pdf: _pdfHooks,
    attachmentWithFeedback: _attachmentHooks,
    attachmentTreeWithFeedback: _attachmentTreeHooks,
    electricDiagram: _electricDiagramHooks,
    documentation: _treeHooks,
    drilldown: _treeHooks,
    equipmentDocumentation: _treeHooks,
    equipmentErrorTrees: _treeHooks,
    equipmentBulletin: _treeHooks,
    serviceReference: _treeHooks,
    submitFeedback: _submitFeedbackHooks,
    successFeedback: _successHooks,
    submitFavorite: _submitFavoriteHooks,
    successFavorite: _successHooks,

    installationReportCreate: _installationReportCreateHooks,
    installationReportEdit: _installationReportEditHooks,
    installationReportSubmit: _installationReportSubmitHooks,
  },
}

export default hooks
